import { Component } from "@angular/core";
import { PermissionsEnum } from "src/app/shared/Models/enums/PermissionsEnum";
import { PermissionsService } from "src/app/shared/services/permissions.service";
import { ToastService } from "../../shared/toast.service";

@Component({
  selector: "app-admin-panel",
  templateUrl: "./admin-panel.component.html",
  styleUrls: ["./admin-panel.component.scss"],
  providers: [ToastService],
})
export class AdminPanelComponent {
  constructor(private permissionsService: PermissionsService) {}

  get commandUploadsAllowed() {
    return this.permissionsService.allowed(PermissionsEnum.ViewCommandUploads);
  }

  get userManagerAllowed() {
    return this.permissionsService.allowed(PermissionsEnum.UserManager);
  }

  get initialLoadAllowed() {
    return this.permissionsService.allowed(PermissionsEnum.TriggerInitialLoad);
  }

  get documentTemplatesAllowed() {
    return this.permissionsService.allowed(PermissionsEnum.ViewTemplates);
  }

  get lstExportAllowed() {
    return this.permissionsService.allowed(PermissionsEnum.ExportLstData);
  }

  get bulkAllowed() {
    return this.permissionsService.allowed(PermissionsEnum.BulkUpload);
  }

  get lomImportAllowed() {
    return this.permissionsService.allowed(PermissionsEnum.LomImport);
  }

  get settingsAllowed() {
    return this.permissionsService.allowed(PermissionsEnum.Settings);
  }
  get maintenancemessagesAllowed() {
    return this.permissionsService.allowed(PermissionsEnum.Settings);
  }
}
